import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
} from "reactstrap";
import SimpleBar from "simplebar-react";
import { Link } from "react-router-dom";
import type { RecentActivityRow } from "../../utils/dashboardMetrics";

interface RecentActivityProps {
  rows: RecentActivityRow[];
  loading?: boolean;
}

const iconForType = (type: string) => {
  const lower = type.toLowerCase();
  if (lower.includes("hotel")) return "bx bx-building-house";
  if (lower.includes("tour")) return "bx bx-map";
  if (lower.includes("transfer")) return "bx bx-car";
  if (lower.includes("package")) return "bx bx-package";
  return "bx bx-receipt";
};

const RecentActivity = ({ rows, loading }: RecentActivityProps) => {
  return (
    <React.Fragment>
      <Col xl={4}>
        <Card>
          <CardHeader className="align-items-center d-flex">
            <h4 className="card-title mb-0 flex-grow-1">Recent Activity</h4>
          </CardHeader>

          <CardBody className="px-0">
            {loading ? (
              <div className="text-center py-4">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <SimpleBar className="px-3" style={{ maxHeight: "352px" }}>
                <ul className="list-unstyled activity-wid mb-0">
                  {rows.length === 0 ? (
                    <li className="text-muted text-center py-4">
                      No data available for this period
                    </li>
                  ) : (
                    rows.map((row) => (
                      <li
                        key={`activity-${row.orderId}-${row.reference}`}
                        className="activity-list activity-border"
                      >
                        <div className="activity-icon avatar-md">
                          <span className="avatar-title bg-primary-subtle text-primary rounded-circle">
                            <i className={`${iconForType(row.type)} font-size-24`}></i>
                          </span>
                        </div>
                        <div className="d-flex">
                          <div className="flex-grow-1 overflow-hidden me-2">
                            <h5 className="font-size-14 mb-1">
                              <Link to={`/orders/${row.orderId}`} className="text-dark">
                                {row.date}
                              </Link>
                            </h5>
                            <p className="text-muted mb-0 text-truncate">
                              {row.customer} · {row.type} · {row.reference}
                            </p>
                          </div>
                          <div className="flex-shrink-0 text-end">
                            <h5 className="font-size-13 mb-1">{row.amount}</h5>
                            <p className="text-muted mb-0 font-size-12">{row.status}</p>
                          </div>
                        </div>
                      </li>
                    ))
                  )}
                </ul>
              </SimpleBar>
            )}
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default RecentActivity;
